import { createSlice } from '@reduxjs/toolkit';

// 定义初始状态
const initialState = {
    basedata:{},
    userInfo: {},
    language:{}
};

const appSlice = createSlice({
    name: 'app', // slice 名称
    initialState, // 初始状态
    reducers: {
        setUser: (state,action) => {
            state.userInfo = action.payload;
        },
        setbase:(state,action) => {
            state.basedata = action.payload;
        },
        setlanguage:(state,action) => {
            state.language = action.payload;
        },
    },
});

// 导出 action creators 和 reducer
export const { setUser,setbase,setlanguage } = appSlice.actions;
export default appSlice.reducer;
